/**
 * Numbers used to check a document or something containing numbers.
 */
export type CheckSums = [number, number];

/**
 * Generate check sums. Multiply numbers to validators and sum them to generate
 * check sums, they're used to check if numbers are valid.
 * @param numbers - Numbers used to generate checkers.
 * @param validators - Validators used to generate checkers.
 */
const generateCheckSums = (
  numbers: Array<number>,
  validators: Array<number>
): CheckSums => {
  const initialCheckSums: CheckSums = [0, 0];

  return validators.reduce(
    ([checkerA, checkerB], validator, index) =>
      [
        index === 0 ? 0 : checkerA + (numbers[index - 1] ?? 0) * validator,
        checkerB + (numbers[index] ?? 0) * validator,
      ] as CheckSums,
    initialCheckSums
  );
};

export default generateCheckSums;
